import { TranslateW, Translate } from "./Translate"
import { FormattedMessage, useIntl } from 'react-intl';

export const TranslateArray = (intl, dropdowns, type) => {
    const options = dropdowns.map((obj) => ({
        ...obj,
        id : obj.id,
        name : intl.formatMessage({id : `${type}.${obj.id}`})
    }));

    return options
};